import NotificationsFeed from "@/components/MCAFeed";
import ComplianceSuggestPanel from "@/components/ComplianceSuggestPanel";

export default function Notifications() {
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10" data-testid="notifications-page">
      <div className="mb-6">
        <div className="label-eyebrow mb-2">Live · MCA · SAG Infotech</div>
        <h1 className="font-heading text-4xl font-light tracking-tight">Compliance Notifications</h1>
        <p className="text-zinc-600 max-w-2xl text-sm mt-2 leading-relaxed">
          Auto-refreshed daily at 06:00 IST from MCA and SAG Infotech. Click any item to read in-app, or generate AI-powered action items for any company below.
        </p>
      </div>
      <ComplianceSuggestPanel />
      <NotificationsFeed fullPage />
    </div>
  );
}
